// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/spomienky/:vylet\",\"regex\":\"^/spomienky/([^/]+)$\",\"paramNames\":[\"vylet\"],\"hasOptionalPrefix\":false},{\"path\":\"/vylety/:vylet\",\"regex\":\"^/vylety/([^/]+)$\",\"paramNames\":[\"vylet\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/dokumenty-na-stiahnutie\"},{\"path\":\"/faq\"},{\"path\":\"/kontakt\"},{\"path\":\"/o-nas\"},{\"path\":\"/objednavka\"},{\"path\":\"/poukazka\"},{\"path\":\"/spomienky\"},{\"path\":\"/vylet-na-mieru\"},{\"path\":\"/vylety\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b9d5a2b60f872d2431e96a98d46a744f@o4507175714357248.ingest.de.sentry.io/4510465093206096",

  environment:
    process.env.SENTRY_ENVIRONMENT ?? process.env.VERCEL_ENV ?? "local",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
